import { render, staticRenderFns } from "./templateTable.vue?vue&type=template&id=75bc956e&scoped=true"
import script from "./templateTable.vue?vue&type=script&lang=ts"
export * from "./templateTable.vue?vue&type=script&lang=ts"
import style0 from "./templateTable.vue?vue&type=style&index=0&id=75bc956e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bc956e",
  null
  
)

export default component.exports